"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    LayersSolid: function() {
        return LayersSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const LayersSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11.5144 1.12584C11.8164 0.958052 12.1836 0.958052 12.4856 1.12584L21.4856 6.12584C21.8031 6.30221 22 6.63683 22 7C22 7.36317 21.8031 7.69779 21.4856 7.87416L12.4856 12.8742C12.1836 13.0419 11.8164 13.0419 11.5144 12.8742L2.51436 7.87416C2.19689 7.69779 2 7.36317 2 7C2 6.63683 2.19689 6.30221 2.51436 6.12584L11.5144 1.12584Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M4.41135 15.072L2.51436 16.1259C2.19689 16.3023 2 16.6369 2 17.0001C2 17.3632 2.19689 17.6978 2.51436 17.8742L11.5144 22.8742C11.8164 23.042 12.1836 23.042 12.4856 22.8742L21.4856 17.8742C21.8031 17.6978 22 17.3632 22 17.0001C22 16.6369 21.8031 16.3023 21.4856 16.1259L19.5887 15.072L12.9713 18.7483C12.3672 19.0839 11.6328 19.0839 11.0287 18.7483L4.41135 15.072Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M2.51436 11.1259L4.41135 10.072L11.0287 13.7483C11.6328 14.0839 12.3672 14.0839 12.9713 13.7483L19.5887 10.072L21.4856 11.1259C21.8031 11.3023 22 11.6369 22 12.0001C22 12.3632 21.8031 12.6979 21.4856 12.8742L12.4856 17.8742C12.1836 18.042 11.8164 18.042 11.5144 17.8742L2.51436 12.8742C2.19689 12.6979 2 12.3632 2 12.0001C2 11.6369 2.19689 11.3023 2.51436 11.1259Z",
            fill: "currentColor"
        })
    ]
}), "LayersSolid");
const _default = LayersSolid;
